export default __webpack_public_path__ + "static/Annual_Multimedia_logo-06e3ea045d0df966ba91f925220c46dc.svg";